/**
 * SECURITY FIX: Production-safe logger
 * Only logs to console in development environment
 * In production, logs are suppressed to prevent data leakage
 */

// Create React App uses process.env.NODE_ENV
const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  warn: (...args: any[]) => {
    // Always show warnings (but can be disabled in production if needed)
    console.warn(...args);
  },

  error: (...args: any[]) => {
    // Always show errors (these should be sent to error tracking in production)
    console.error(...args);

    // TODO: Send to Sentry or other error tracking service in production
    // if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    //   Sentry.captureException(args[0]);
    // }
  },

  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  table: (data: any) => {
    if (isDevelopment && console.table) {
      console.table(data);
    }
  }
};

// Export as default for convenience
export default logger;
